export default __webpack_public_path__ + "static/media/Logo-NEXT-Business-negativo.d4ad2995.svg";